// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"ceffbb0b","893":"b03a523f"}[chunkId] + ".chunk.js";
};